import _defineProperty from "@babel/runtime-corejs3/helpers/defineProperty";
import _slicedToArray from "@babel/runtime-corejs3/helpers/slicedToArray";
import _trimInstanceProperty from "@babel/runtime-corejs3/core-js-stable/instance/trim";
import React, { useState } from "react";
import { makeStyles } from "@mui/styles";
import { Typography, RaiseColors, IconButton, Icon, IconConstants } from "componentLibrary";
import TextField from "components/mui/Fields/Fields/TextField/TextField";
import MuiFormikField from "dashboard/Invoicing/common/MuiFormikField";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
var useStyles = makeStyles(function (theme) {
  return {
    rowContainer: {
      display: "flex",
      justifyContent: "space-between",
      width: "100%",
      alignItems: "center"
    },
    iconContainer: {
      display: "flex",
      gap: "8px"
    },
    editContainer: {
      display: "flex",
      gap: "8px",
      alignItems: "center",
      justifyContent: "space-between",
      flex: 1
    }
  };
});
var DropdownOptionRow = function DropdownOptionRow(_ref) {
  var _errors$dropdownOptio, _errors$dropdownOptio2;
  var item = _ref.item,
    onDelete = _ref.onDelete,
    onSave = _ref.onSave,
    isDuplicate = _ref.isDuplicate,
    index = _ref.index,
    isEditing = _ref.isEditing,
    setIsEditing = _ref.setIsEditing,
    errors = _ref.errors,
    setErrors = _ref.setErrors;
  var classes = useStyles();
  var _useState = useState(item.label),
    _useState2 = _slicedToArray(_useState, 2),
    editValue = _useState2[0],
    setEditValue = _useState2[1];
  var handleEditClick = function handleEditClick() {
    setIsEditing(index);
    if (isDuplicate(_trimInstanceProperty(editValue).call(editValue), index)) {
      setErrors === null || setErrors === void 0 || setErrors({
        dropdownOptions: _defineProperty({}, index, "This name already exists")
      });
      return;
    }
    setEditValue(item.label);
    setErrors === null || setErrors === void 0 || setErrors({
      dropdownOptions: _defineProperty({}, index, null)
    });
  };
  var handleSaveClick = function handleSaveClick() {
    if (_trimInstanceProperty(editValue).call(editValue) === "") {
      setErrors === null || setErrors === void 0 || setErrors({
        dropdownOptions: _defineProperty({}, index, "Cannot be empty")
      });
      return;
    }
    if (isDuplicate(_trimInstanceProperty(editValue).call(editValue), index)) {
      setErrors === null || setErrors === void 0 || setErrors({
        dropdownOptions: _defineProperty({}, index, "This name already exists")
      });
      return;
    }
    onSave(index, _trimInstanceProperty(editValue).call(editValue));
    setIsEditing(false);
    setErrors === null || setErrors === void 0 || setErrors({
      dropdownOptions: _defineProperty({}, index, null)
    });
  };
  var handleCancelClick = function handleCancelClick() {
    setIsEditing(false);
    setEditValue(item.label);
    setErrors === null || setErrors === void 0 || setErrors({
      dropdownOptions: _defineProperty({}, index, null)
    });
  };
  var handleKeyDown = function handleKeyDown(e) {
    if (e.key === "Enter") {
      e.preventDefault();
      handleSaveClick();
    } else if (e.key === "Escape") {
      e.preventDefault();
      handleCancelClick();
    }
  };
  var isCurrentlyEditing = isEditing === index;
  var hasErrors = !!(errors !== null && errors !== void 0 && (_errors$dropdownOptio = errors.dropdownOptions) !== null && _errors$dropdownOptio !== void 0 && _errors$dropdownOptio[index]);
  var errorMessage = errors === null || errors === void 0 || (_errors$dropdownOptio2 = errors.dropdownOptions) === null || _errors$dropdownOptio2 === void 0 ? void 0 : _errors$dropdownOptio2[index];
  if (isCurrentlyEditing) {
    return /*#__PURE__*/_jsx("div", {
      className: classes.rowContainer,
      children: /*#__PURE__*/_jsxs("div", {
        className: classes.editContainer,
        children: [/*#__PURE__*/_jsx(MuiFormikField, {
          Component: TextField,
          value: editValue,
          name: "edit-".concat(item.id),
          placeholder: "Type your option and press Enter",
          fullWidth: true,
          onChange: function onChange(e) {
            setEditValue(e.target.value);
            setErrors === null || setErrors === void 0 || setErrors({
              dropdownOptions: _defineProperty({}, index, null)
            });
          },
          editMode: true,
          disabled: isEditing !== index,
          size: "small",
          autoFocus: true,
          onKeyDown: handleKeyDown,
          error: hasErrors,
          helperText: errorMessage,
          sx: {
            "& .MuiInputBase-root": {
              backgroundColor: "white"
            }
          }
        }), errorMessage && /*#__PURE__*/_jsx(Typography, {
          variant: "paragraph_small",
          color: RaiseColors.destructive700,
          children: errorMessage
        }), /*#__PURE__*/_jsxs("div", {
          className: classes.iconContainer,
          children: [/*#__PURE__*/_jsx(IconButton, {
            variant: "animatedIcon",
            size: "small",
            onClick: handleSaveClick,
            children: /*#__PURE__*/_jsx(Icon, {
              color: RaiseColors.midnightPurple,
              fontSize: 16,
              className: IconConstants.CHECK
            })
          }), /*#__PURE__*/_jsx(IconButton, {
            variant: "animatedIcon",
            size: "small",
            onClick: function onClick() {
              return onDelete(item);
            },
            children: /*#__PURE__*/_jsx(Icon, {
              color: RaiseColors.midnightPurple,
              fontSize: 16,
              className: IconConstants.TRASH
            })
          })]
        })]
      })
    });
  }
  var isDisabled = isEditing !== false;
  var iconColor = isDisabled ? RaiseColors.gray200 : RaiseColors.midnightPurple;
  return /*#__PURE__*/_jsxs("div", {
    className: classes.rowContainer,
    children: [/*#__PURE__*/_jsx(Typography, {
      variant: "paragraph_small",
      weight: "medium",
      color: isDisabled ? RaiseColors.gray200 : RaiseColors.midnightPurple,
      children: item.label
    }), /*#__PURE__*/_jsxs("div", {
      className: classes.iconContainer,
      children: [/*#__PURE__*/_jsx(IconButton, {
        variant: "animatedIconSmall",
        size: "small",
        onClick: handleEditClick,
        disabled: isDisabled,
        children: /*#__PURE__*/_jsx(Icon, {
          color: iconColor,
          fontSize: 16,
          className: IconConstants.PENCIL
        })
      }), /*#__PURE__*/_jsx(IconButton, {
        variant: "animatedIconSmall",
        size: "small",
        onClick: function onClick() {
          return onDelete(item);
        },
        disabled: isDisabled,
        children: /*#__PURE__*/_jsx(Icon, {
          color: iconColor,
          fontSize: 16,
          className: IconConstants.TRASH
        })
      })]
    })]
  });
};
export default DropdownOptionRow;